export default "__VITE_ASSET__C0x0QqqI__"